import { connect } from 'react-redux';

import ButtonPublish from '../../../components/Editor/ButtonPublish';
import { StoreState } from '../../../reducers';
import { getClientAndResourceIds } from '../utils/helpers';
import Utils from '../../../utils';
import { Api } from '../../../typings/api';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			label: { label },
			preprodPublication: { lastUpdateDate, isUpdating, urlWithPin },
			settings: { projectUrl },
			invoiceStatus,
			publishPrice: { actionCredits = {}},
		},
		driveList: { driveItems },
		galleryInfos: {
			template: { sharedNetworks },
		},
		profile: { customer: { accType }},
	} = state;

	const { clientId, originalGId, tempGId } = getClientAndResourceIds();
	const driveItem = driveItems[originalGId];

	const isPublishDue =
		accType === Api.AccountType.PREPAID
		&& invoiceStatus === Api.AssetItemInvoiceStatus.DEMO;

	const hasActionCredits = Object.keys(actionCredits).length > 0;

	return {
		projectUrl,
		urlWithPin,
		clientId,
		originalGId,
		tempGId,
		label,
		driveItem,
		isShareByCopyEnabled: Utils.isEmbedMode() ||
			Utils.isShareOnlyViaCopyEnabled(sharedNetworks) ||
			Utils.isMultipleShareEnabled(sharedNetworks),
		isShareByEmailEnabled: !Utils.isEmbedMode() && (
			Utils.isShareOnlyViaUprezEnabled(sharedNetworks) ||
			Utils.isMultipleShareEnabled(sharedNetworks)
		),
		lastUpdateDate,
		isUpdating,
		isPublishDue,
		actionCredits: hasActionCredits ? actionCredits : {},
	};
};

export default connect(mapStateToProps)(ButtonPublish);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonPublish/index.tsx